import { Navigate, Outlet, useLocation } from "react-router-dom";
import UserAuthStore from "../../store/userStore";
import Loader from "../../components/Loader/Loader";

const ProtectedRoute = () => {
  const user = UserAuthStore((state) => state.user);
  const authStatus = UserAuthStore((state) => state.authStatus);
  const location = useLocation();

  if (authStatus === "resolving") {
    return (
      <div className="h-screen flex items-center justify-center bg-surface-page">
        <Loader />
      </div>
    );
  }

  return authStatus === "authenticated" && user?.uid
    ? <Outlet />
    : <Navigate to="/" replace state={{ from: `${location.pathname}${location.search}` }} />;
};

export default ProtectedRoute;
